import React from 'react'

import { SubHeader } from 'components'

const Home = () => (
  <SubHeader
    breadcrumb={[
      {
        text: 'Home',
        href: '/',
      },
    ]}
    heading="Home"
  />
)

export default Home
